export default __webpack_public_path__ + "static/media/Hammer&Partner.77703354.png";